const goBack = () => {
  window.history.go(-1);
};

Array.prototype.slice
  .call(document.querySelectorAll('.back-link'))
  .forEach((backlink) => {
    backlink.addEventListener('click', goBack, false);
  });
